define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/XMLUtil',
	'model/RequestedAttribute',
	'model/AuthenticationOption',
	'lib/jquery'
], function (
		Logger,
		Util,
		XMLUtil,
		RequestedAttribute,
		AuthenticationOption,
		jQuery
		) {
	'use strict';

	/**
	 * RequestedAttributesFactory class
	 */
	return new function () {
		var metadataNamespace = 'urn:oasis:names:tc:SAML:2.0:metadata',
				privacyProfileNamespace = 'urn:oasis:names:tc:SAML:profile:privacy';

		// private methods

		function resolveOriginFromOption(optionId, option) {
			var derivedCreds = option.derivedCredentials(),
					i;
			
//                        console.groupCollapsed(option.id()+" - resolveOriginFromOption ("+optionId+")");
			for (i = 0; i < derivedCreds.length; i++) {
//                            console.info(derivedCreds[i].id());
				if (optionId === derivedCreds[i].id()) {
//                                    console.groupEnd();
					return derivedCreds[i];
				}
			}
//                        console.groupEnd();
			
			throw new Error('requested attribute referes to non-existing derived credentials in option : ' + optionId); 
		}

		function resolveOriginFromGroup(optionId, group) {
			var options = group.authenticationOptions(),
					i;
			
			for (i = 0; i < options.length; i++) {
				try {
					return resolveOriginFromOption(optionId, options[i]);
				} catch (error) {
					// optionId not found in derivedCredentials of this option, so, continue with next
				}
			}
			
			throw new Error('requested attribute referes to non-existing option : ' + optionId); 
		}

		// public methods

		this.create = function (optionsXML) {
			var attributeConsumingService = XMLUtil.find(metadataNamespace, optionsXML, 'AttributeConsumingService'),
					requestedAttributeInfos = XMLUtil.find(privacyProfileNamespace, optionsXML, 'RequestedAttributeInfos'),
					requestedAttributes = new Array(),
					requestedAttributesXML,
					requestedAttributeInfoXML,
					name,
					isRequired,
					purpose,
					i, j;

			requestedAttributesXML = XMLUtil.find(metadataNamespace, attributeConsumingService, 'RequestedAttribute');
			
			if (requestedAttributesXML === null || requestedAttributesXML.length === 0) {
				return requestedAttributes;
			}

			if (requestedAttributeInfos.length !== 0) {
				requestedAttributeInfoXML = XMLUtil.find(privacyProfileNamespace, requestedAttributeInfos, 'RequestedAttributeInfo');
			}

			for (i = 0; i < requestedAttributesXML.length; i++) {
				requestedAttributesXML[i] = jQuery(requestedAttributesXML[i]);

				name = requestedAttributesXML[i].attr('Name').trim();
				isRequired = (requestedAttributesXML[i].attr('isRequired') !== undefined) ?
						((requestedAttributesXML[i].attr('isRequired') === 'true') ? true : false) : false;

				purpose = null;

				if (requestedAttributeInfos.length !== 0) {
					for (j = 0; j < requestedAttributeInfoXML.length; j++) {
						requestedAttributeInfoXML[j] = jQuery(requestedAttributeInfoXML[j]);

						if (requestedAttributeInfoXML[j].attr('AttributeName') === name) {
							purpose = XMLUtil.find(privacyProfileNamespace, requestedAttributeInfoXML[j], 'Purpose').text().trim();
							break;
						}
					}
				}

				requestedAttributes.push(new RequestedAttribute(name, isRequired, purpose));
			}

			return requestedAttributes;
		};

		/**
		 * Creates requested attributes for given option or option group.
		 * 
		 * @param {type} optionsXML
		 * @param {type} authenticationOptionXML AuthenticationOption or AuthenticationOptionGroup
		 * @returns {RequestedAttributesFactory_L19.createForAuthenticationOption.requestedAttributes}
		 */
		this.createForAuthenticationOption = function (optionsXML, authenticationOptionXML) {
			var name = null,
					isRequired = null,
					purpose = null,
					origins,
					requestedAttributes = new Array();

			var requestedAttributeInfos = XMLUtil.find(privacyProfileNamespace, optionsXML, 'RequestedAttributeInfos');

			var requestedAttributesXML = XMLUtil.find(privacyProfileNamespace, authenticationOptionXML, 'RequestedAttribute'),
					requestedAttributeInfoXML;

			if (requestedAttributesXML === null || requestedAttributesXML.length === 0) {
				return requestedAttributes;
			}

			if (requestedAttributeInfos.length !== 0) {
				requestedAttributeInfoXML = XMLUtil.find(privacyProfileNamespace, requestedAttributeInfos, 'RequestedAttributeInfo');
			}

			for (var i = 0; i < requestedAttributesXML.length; i++) {
				requestedAttributesXML[i] = jQuery(requestedAttributesXML[i]);

				name = requestedAttributesXML[i].attr('Name').trim();
				origins = requestedAttributesXML[i].attr('AuthenticationOptionRef');
				isRequired = (requestedAttributesXML[i].attr('isRequired') !== undefined) ?
						((requestedAttributesXML[i].attr('isRequired') === 'true') ? true : false) : false;

				purpose = null;

				if (requestedAttributeInfos.length !== 0) {
					for (var j = 0; j < requestedAttributeInfoXML.length; j++) {
						requestedAttributeInfoXML[j] = jQuery(requestedAttributeInfoXML[j]);

						if (requestedAttributeInfoXML[j].attr('AttributeName') === name) {
							purpose = XMLUtil.find(privacyProfileNamespace, requestedAttributeInfoXML[j], 'Purpose').text().trim();
							break;
						}
					}
				}

				if (typeof origins !== "undefined") {
					origins = origins.trim();
					origins = origins.split(" ");
					//Empty OptionsRef
					if (origins[0] === "") {
						origins = null;
					}
				}
				
				// origins is now array of OptionID's it will be converted to array of Origin classes later
				requestedAttributes.push(new RequestedAttribute(name, isRequired, purpose, origins));
			}

			return requestedAttributes;
		};
		
		this.resolveOrigins = function (authenticationOptionsOrGroups) {
			var i, j, k,
					reqAttrs,
					optionIds,
					optionOrGroup;
			
			for (i = 0; i < authenticationOptionsOrGroups.length; i++) {
				optionOrGroup = authenticationOptionsOrGroups[i];
				reqAttrs = optionOrGroup.requestedAttributes();
				for (j = 0; j < reqAttrs.length; j++) {
					// origin is still list of OptionIDs
					optionIds = reqAttrs[j].origin();
					for (k = 0; k < optionIds.length; k++) {
						if (optionIds[k] instanceof AuthenticationOption) {
							// already resolved, so, nothing to do
							continue;
						}
						// convert OptionID to Origin
						if (optionOrGroup instanceof AuthenticationOption) {
							// optionOrGroup is AuthenticationOption
							optionIds[k] = resolveOriginFromOption(optionIds[k], optionOrGroup);
						} else {
							// optionOrGroup is AuthenticationOptionGroup
							optionIds[k] = resolveOriginFromGroup(optionIds[k], optionOrGroup);
						}
					}
				}
				if (!(optionOrGroup instanceof AuthenticationOption)) {
					// optionOrGroup is group, so, also resolve origins in options inside this group
					this.resolveOrigins(optionOrGroup.authenticationOptions());
				}
			}
		}
		
		this.createFromAttributeIdentifiers = function (attributeIdentifiers) {
			var requestedAttributes = new Array(),
					i;

			for (i = 0; i < attributeIdentifiers.length; i++) {
				requestedAttributes.push(new RequestedAttribute(attributeIdentifiers[i], false));
			}

			return requestedAttributes;
		};

		this.createFromObject = function (requestedAttributeObject) {
			var requestedAttributes,
					i;

			if (Util.isArray(requestedAttributeObject)) {
				requestedAttributes = new Array();

				for (i = 0; i < requestedAttributeObject.length; i++) {
					requestedAttributes.push(new RequestedAttribute(
							requestedAttributeObject[i]['name'],
							requestedAttributeObject[i]['isRequired'],
							requestedAttributeObject[i]['purpose']));
				}
			} else {
				requestedAttributes = new RequestedAttribute(
						requestedAttributeObject['name'],
						requestedAttributeObject['isRequired'],
						requestedAttributeObject['purpose']);
			}

			return requestedAttributes;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/RequestedAttributesFactory.js
// module id = 52
// module chunks = 8